import React from 'react';
import ReactDOM from 'react-dom';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import {CloseRounded} from "@mui/icons-material";
import { Card, Space, Typography, Row, Col } from 'antd';
import Refresh from "./Refresh";

const Orientation = ({ title, children, visible, onToggle }) => {
  // Use a portal to mount the orientation component directly to the body
  // This ensures it's on top of everything else
  return visible ? ReactDOM.createPortal(
    (
      <div className={''} style={{
        position: 'fixed',
        top: 20,
        right: 20,
        zIndex: 1000, // Ensure it's above most other elements
        maxWidth: 300,
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        borderRadius: 4,
        overflow: 'hidden'
      }}>
        <div className={'card-md'}
          title={title}
          style={{ width: '100%', maxHeight: 400, minWidth: 300 }}
        >
            <Row justify={'space-between'} className={'pl-3 pt-2'} align={'middle'}>
                <div style={{fontSize: 16, fontWeight: 600}}>{title}</div>
                <Button variant={'text'} color={'error'} size={'small'} onClick={()=>onToggle(false)}><CloseRounded/></Button>
            </Row>
            <div style={{padding: '10px 20px'}}>
                <Space direction={'vertical'} style={{color: "#333", fontSize: '12px', fontFamily: "var(--font-family)", fontWeight: '500'}}>
                    {children}
                </Space>
            </div>
        </div>
      </div>
    ),
    document.body // Mounting target
  ) : <Refresh onClick={() => onToggle(true)}/>;
};

export default Orientation;
